import { MenuItem } from './menu.item.model';

export interface SalesMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: SalesMenuSection[] = [
  {
    title: 'nav-item.home.title',
    items: [
      { icon: 'home', name: 'nav-item.home.home', route: '/home' },
    ],
  },
  {
    title: 'nav-item.operational.title',
    items: [
      { icon: 'business', name: 'nav-item.operational.sites', route: '/worker/sites' },
      { icon: 'briefcase-outline', name: 'nav-item.operational.projects', route: '/projects' },
      { icon: 'reader-outline', name: 'nav-item.operational.tasks', route: '/manager/tasks' },
    ],
  },
  {
    title: 'nav-item.business.title',
    items: [
      { icon: 'albums', name: 'nav-item.business.customers', route: '/clients' },
      { icon: 'cash', name: 'nav-item.business.additionalWork', route: '/contractors/sales' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      { icon: 'help-circle-outline', name: 'nav-item.support.help', route: '/support' },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const salesMenu = {
  sections,
  items,
};
